var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFollower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.332,
    height: 65.332,
    viewBox: "0 0 65.332 65.332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user_1_",
    "data-name": "user (1)",
    d: "M60.15,41.472a30.6,30.6,0,0,0-7.805-4.886,2.552,2.552,0,0,0-2.073,4.664,25.523,25.523,0,0,1,6.509,4.055,10.176,10.176,0,0,1,3.447,7.649v4.721a2.555,2.555,0,0,1-2.552,2.552H7.656A2.555,2.555,0,0,1,5.1,57.676V52.955a10.176,10.176,0,0,1,3.447-7.649C11.13,43.04,18.642,37.77,32.666,37.77a18.907,18.907,0,1,0-11.5-3.919A35.479,35.479,0,0,0,5.183,41.472,15.281,15.281,0,0,0,0,52.955v4.721a7.664,7.664,0,0,0,7.656,7.656h50.02a7.664,7.664,0,0,0,7.656-7.656V52.955A15.281,15.281,0,0,0,60.15,41.472ZM18.885,18.885A13.781,13.781,0,1,1,32.666,32.666,13.8,13.8,0,0,1,18.885,18.885Zm0,0",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFollower);
export default __webpack_public_path__ + "static/media/ic_follower.fc241371239f12ea8b9bc1cc6a5bf179.svg";
export { ForwardRef as ReactComponent };